import React, { ReactNode, useEffect } from "react";
import { Nullable } from "../../../../types/utils";
import { OrderCostingVersion, TApiOrderDetails } from "../../../api/endpoints/Order";
import OrderCostSummaryV1 from "./OrderCostSummaryV1";
import OrderCostSummaryV2 from "./OrderCostSummaryV2";
import classNames from "classnames";
import OrderCostSummaryV3 from "./OrderCostSummaryV3";
import OrderCostSummaryV4 from "./OrderCostSummaryV4";
import OrderCostSummaryV5 from "./OrderCostSummaryV5";
import OrderCostSummaryV6 from "./OrderCostSummaryV6";

interface IProps {
  order: TApiOrderDetails;
  currentCostingVersion?: Nullable<OrderCostingVersion>;
  annualTotalCostFootnoteRef?: string;
  additionalContent?: ReactNode;
}

const OrderCostSummary = (props: IProps) => {
  const { order, currentCostingVersion, annualTotalCostFootnoteRef, additionalContent } = props;
  const { version } = order.cost;

  return (
    <div className={classNames("order-cost-summary", version)}>
      {
        version === 'v1' &&
        <OrderCostSummaryV1
          cost={order.cost}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v2' &&
        <OrderCostSummaryV2
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
          additionalContent={additionalContent}
        />
      }

      {
        version === 'v3' &&
        <OrderCostSummaryV3
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
          additionalContent={additionalContent}
        />
      }

      {
        version === 'v4' &&
        <OrderCostSummaryV4
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
          additionalContent={additionalContent}
        />
      }

      {
        version === 'v5' &&
        <OrderCostSummaryV5
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
          additionalContent={additionalContent}
        />
      }

      {
        version === 'v6' &&
        <OrderCostSummaryV6
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
          additionalContent={additionalContent}
        />
      }
    </div>
  )
}

export default OrderCostSummary;
